import { Page, Document, StyleSheet } from "@react-pdf/renderer";
import { Quotation, Setting } from "../../../generated/graphql";
import QuotationHeader from "./Header";
import QuotationItems from "./Items";
import QuotationPaymentInfo from "./PaymentInfo";
import QuotationSignature from "./Signature";
import QuotationSocials from "./Socials";

const PrintQuotation: React.FC<{
  quotation: Quotation;
  settings?: Setting[];
}> = ({ quotation, settings }) => (
  <Document>
    <Page size={[500, 792]} style={styles.page} orientation="portrait">
      <QuotationHeader quotation={quotation} />
      <QuotationItems quotation={quotation} />
      <QuotationPaymentInfo quotation={quotation} settings={settings} />
      <QuotationSignature quotation={quotation} />
      <QuotationSocials />
    </Page>
  </Document>
);

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 24,
    paddingRight: 24,
  },
});

export default PrintQuotation;
